import React from 'react';
import { connect } from 'react-redux';
import store from '../store/store';
import classnames from 'classnames';
import ValueReferencePlugin from '../plugins/tinymce-value-reference';
import AssetManagerReferencePlugin from '../plugins/tinymce-asset-manager-reference';
import { addNotification } from '../actions/reduxActions/notification';
import translations from '../translations';
import '../../css/flow.less';

const guid = function() {

    let s4 = function() {

        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);

    };

    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();

};

class Flow extends React.Component {

    constructor(props) {
        super(props);
        this.id = 'flow-' + guid();
        this.state = { isTransitioning: true }
    }

    onMount() {
        let options = {
            trackLocation: false,
            replaceUrl: false,
            collaboration: {
                isEnabled: false
            },
            inputs: null,
            annotations: null,
            navigation: {
                isFixed: true
            },
            paging: {
                'VALUE_SELECTOR': 500
            },
            isFullWidth: true,
            callbacks: null,
            containerSelector: '#' + this.id,
            richText: {
                fontSize: '14px',
                plugins: [
                    "importcss",
                    "advlist autolink link lists link image charmap print hr anchor",
                    "searchreplace visualblocks fullscreen wordcount code insertdatetime",
                    "media table directionality emoticons contextmenu paste textcolor",
                    "manywho_elements",
                    "assets_manager"
                ],
                custom_plugins: {
                    "manywho_elements": ValueReferencePlugin,
                    "assets_manager": AssetManagerReferencePlugin
                },
                toolbar: 'undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image | manywho_elements',
                content_css: ['/css/tenant/' + this.props.tenantId + '/customstyles'],
                importcss_append: true,
                importcss_file_filter: '/css/tenant/' + this.props.tenantId + '/customstyles',
                imageUploadEnabled: true,
            },
            disableScripting: true,
        };

        if (this.props.options) {
            options = manywho.utils.extend(options, this.props.options, true);
        }

        if (this.props.callbacks) {

            if (Array.isArray(this.props.callbacks)) {
                options.callbacks = this.props.callbacks.map((callback) => {
                    return callback
                });
            }
            else if (typeof this.props.callbacks === 'function') {
                options.callbacks = [{ execute: this.props.callbacks, type: 'done' }];
            } else {
                options.callbacks = [this.props.callbacks];
            }

        }

        let inputs = this.props.inputs || [];

        if (this.props.authenticationToken) {
            inputs.push({AuthenticationToken: this.props.authenticationToken});
        }

        // We supply the current tenant ID to system flows, not the admin tenant ID or the flow's default content value
        if (this.props.tenantId) {
            inputs.push({
                FlowTenantId: this.props.tenantId
            });
        }

        inputs = manywho.json.generateFlowInputs(inputs);

        this.setState({ isTransitioning: false });

        requestAnimationFrame(() => {

            manywho.engine.initializeSimple(
                manywho.adminTenantId,
                this.props.flowName,
                this.props.flowId,
                this.props.flowVersionId,
                null,
                null,
                inputs,
                options,
                this.props.component
            )
            .done((flowKey) => {
                this.flowKey = flowKey;
            })
            .fail(
                error => store.dispatch(addNotification({
                    type: 'error',
                    message: error.message || translations['cannot initialize flow'],
                    isPersistent: true,
                })),
            );
        });
    }

    componentDidMount() {
        if (this.props.transition) {
            setTimeout(() => {
                this.onMount();
            }, this.props.transition);
        }
        else {
            this.onMount();
        }
    }

    componentWillUnmount() {
        if (this.flowKey) {
            manywho.utils.removeFlow(this.flowKey);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (!this.props.restart && nextProps.restart) {
            this.componentWillUnmount();
            this.onMount();
        }
    }

    render() {
        const className = classnames({
            'flow-modal-standalone': this.props.component === 'modal-standalone',
            flow: this.props.component !== 'modal-standalone',
            [this.props.className]: !manywho.utils.isNullOrEmpty(this.props.className),
        });

        const wait = !manywho.utils.isNullOrUndefined(this.props.transition)
            && this.state.isTransitioning
            && React.createElement(manywho.component.getByName('wait'), { isVisible: true }, null);

        return (<div id={this.id} className={className}>{wait}</div>);
    }

}

export default connect(
    ({ currentUser: { authenticationToken, tenantId } }) => ({ authenticationToken, tenantId }),
)(Flow);
